import type {ExtraInfo} from './data/types';

import {CSSStyles} from '../../types/CSSStyles';
import Image from '../Image/Image';

import React from 'react';

export interface Props {
  readonly extraData: Maybe<ExtraInfo>;
  readonly style?: CSSStyles;
}

export default function EventThumbnail(props: Props): JSX.Element {
  const {extraData, style} = props;
  const {thumbnailURL} = extraData ?? {};

  if (thumbnailURL == null) {
    return <div />;
  }

  return (
    <Image
      src={thumbnailURL ?? ''}
      sx={style}
      width="100%"
    />
  );
}
